module.exports = __webpack_public_path__ + "static/paris-013.thumb-fe7fb0096cbbeb9e84955ef61dab39bd.jpg";